import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

import { TOUR_USE_CASES, TourUseCases } from '@app/domain/use-cases/tour/tour.use-cases.contract';
import { IStepOption, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';

import { MButtonComponent } from '@mercadona/components-musi/button';
import { MCardComponent, MCardFooterComponent } from '@mercadona/components-musi/card';
import { MTranslatePipe } from '@mercadona/core/translate';
import { MIconComponent } from '@mercadona/icons';

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrl: './tour.component.scss',
  imports: [
    AsyncPipe,
    MTranslatePipe,
    TourStepTemplateComponent,
    MCardComponent,
    MCardFooterComponent,
    MButtonComponent,
    MIconComponent
  ]
})
export class TourComponent implements OnInit {
  #tourUseCases: TourUseCases = inject(TOUR_USE_CASES);
  steps$!: Subject<IStepOption[]>;
  index$!: Subject<number>;

  ngOnInit() {
    this.steps$ = this.#tourUseCases.currentWalkthroughSteps$;
    this.index$ = this.#tourUseCases.stepIndex$;
  }

  hasPrev(step: IStepOption): boolean {
    return this.#tourUseCases.hasPrev(step);
  }

  prev() {
    this.#tourUseCases.onPrevClick();
  }

  next(step: IStepOption) {
    this.#tourUseCases.onNextClick(step);
  }
}
